<template>
  <div class="login">
    <!-- <div class="left"></div> -->
    <div class="right">
      <div class="box">
        <slot />
      </div>
      <p class="tel">
        <!-- <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备xxxx</a> -->
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoginLayout'
}
</script>
<style scoped>
.login {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.left,
.right {
  /*width: 50%;*/
  height: 100%;
}

.left {
  position: relative;
  width: 50%;
  box-sizing: border-box;
  float: left;
  background-size: 100% 100%;
}
.left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.left .text {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 48px;
  line-height: 32px;
}
.left .text h3 {
  font-weight: 400;
  font-size: 26px;
  margin-bottom: 16px;
}
.left .text h4 {
  font-weight: 400;
  color: rgba(255, 255, 255, .6);
}

.right {
  position: relative;
  overflow: hidden;
  overflow-y: scroll;
  box-sizing: border-box;
  padding: 40px 8.33% 0 5%;
  min-width: 50%;
  color: #333;
  /* float: right;*/
  margin: 0 auto;
  box-shadow: 0 12px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
}
.right .box {
  max-width: 520px;
  margin: 0 auto;
  min-height: calc(100vh - 250px);
}
.right .tel {
  /* position: absolute;
  right: 40px;
  bottom: 40px; */
  font-size: 18px;
  font-weight: 400;
  color: #666;
  line-height: 22px;
  text-align: right;
  padding: 120px 36px 24px 0;
}
a {
  color: inherit;
}

</style>
